import React from 'react';
import get from 'lodash/get';
import moment from 'moment';
import { Grid, Typography } from '@mui/material';
import { shortDateTimeFormat2020 } from '../../lib/utils';

function AppCenterInfo({
  appCenter, version,
}) {
  const activeOnList = get(appCenter, 'active') ? 'True' : 'False';
  const addedToList = moment(get(appCenter, 'lastAddedDate')).format(shortDateTimeFormat2020);
  const addedToListBy = get(appCenter, 'lastAddedBy', 'Unknown');
  const removedFromList = moment(get(appCenter, 'lastRemovedDate')).format(shortDateTimeFormat2020);
  const removedFromListBy = get(appCenter, 'lastRemovedBy', 'Unknown');
  const resentInviteToList = moment(get(appCenter, 'lastResentDate')).format(shortDateTimeFormat2020);
  const resentInviteToListBy = get(appCenter, 'lastResentBy', 'Unknown');

  return (
    <Grid container>
      {addedToList && (
        <Grid item xs={12}>
          <Typography variant="caption">
            <strong>
              {version}
              :
            </strong>
            <Typography variant="caption">
              Active:
              {' '}
              {activeOnList}
            </Typography>
          </Typography>
        </Grid>
      )}
      {addedToList && (
        <Grid item xs={12}>
          <Typography variant="caption">
            Last Added:
            {' '}
            {addedToList}
            {' '}
            by
            {' '}
            {addedToListBy}
          </Typography>
        </Grid>
      )}
      {removedFromList && (
        <Grid item xs={12}>
          <Typography variant="caption">
            Last Removed:
            {' '}
            {removedFromList}
            {' '}
            by
            {' '}
            {removedFromListBy}
          </Typography>
        </Grid>
      )}
      {resentInviteToList && (
        <Grid item xs={12}>
          <Typography variant="caption">
            Last Resent:
            {' '}
            {resentInviteToList}
            {' '}
            by
            {' '}
            {resentInviteToListBy}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
}

export default AppCenterInfo;
